import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useQuery } from "react-query";

interface LiveStreamsUsage {
  type: string;
  value: number;
}

export const useLiveStreamsUsage = ({ enabled } = { enabled: true }) => {
  const { data: usageArray, isInitialLoading } = useQuery<LiveStreamsUsage[]>({
    queryKey: [internalApi.liveStreams.usage()],
    enabled,
  });
  const usage: Record<string, number> = {};
  usageArray?.forEach(usageObj => {
    usage[usageObj.type] = usageObj.value;
  });

  return {
    isLoading: isInitialLoading,
    usage,
  };
};
